import { render } from "./TourSimple.vue?vue&type=template&id=24b4b8b0&scoped=true"
import script from "./TourSimple.vue?vue&type=script&lang=js"
export * from "./TourSimple.vue?vue&type=script&lang=js"

import "./TourSimple.vue?vue&type=style&index=0&id=24b4b8b0&scoped=true&lang=scss"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b4b8b0"]])

export default __exports__